import React from 'react';
import { Link, useLocation } from "react-router-dom";
import '../_css/header.css';


function isHere(where, path){return where === path ? "active" : "";}

function Header(){
    const location = useLocation().pathname;
    return(
            <ul className='header'>
                <li style={{ marginLeft: '8%' }}><Link to="/"><img src="./icon_me.jpg" alt="me" className="profile"></img></Link></li>
                <li><Link to="/" className={isHere(location, "/")}>홈</Link></li>
                <li><Link to="/Post" className={isHere(location, "/Post")}>포스트</Link></li>
                <li><Link to="/ETC" className={isHere(location, "/ETC")}>기타</Link></li>
                <li style={{ float: 'right', marginRight: '8%' }}><a href="https://velog.io/">portfolio</a></li>
            </ul>
    );
}

export default Header;

